import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from '@nx-ratenow/core/config';
import { LayoutService } from '@nx-ratenow/core/data-access-layaout';
import { UiUserMenuComponent } from '@nx-ratenow/core/feature-user-menu';
import { NavigationService } from '@nx-ratenow/shared/data-access-utils';
import { AplicationTypeName } from '@nx-ratenow/shared/enums';
import { PopoverService } from '@nx-ratenow/shared/feature-popover';
import { NavigationItem, NavigationLink } from '@nx-ratenow/shared/models';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'nx-ratenow-ui-sidenav',
  templateUrl: './ui-sidenav.component.html',
  styleUrls: ['./ui-sidenav.component.scss']
})
export class UiSidenavComponent implements OnInit {
  @Input() collapsed!: boolean;

  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;

  title$ = this.configService.config$.pipe(map((config) => config?.sidenav.title));

  imageUrl$ = this.configService.config$.pipe(map((config) => config?.sidenav.imageUrl));

  showCollapsePin$ = this.configService.config$.pipe(map((config) => config?.sidenav.showCollapsePin));

  userVisible$ = this.configService.config$.pipe(map((config) => config?.sidenav.user.visible));

  searchVisible$ = this.configService.config$.pipe(map((config) => config?.sidenav.search.visible));

  userMenuOpen$: Observable<boolean> = of(false);
  items: NavigationItem[] = [];

  aplicationType: string;
  aplicationTypeName = AplicationTypeName;

  constructor(
    private navigationService: NavigationService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private readonly popoverService: PopoverService
  ) {
    this.aplicationType = this.configService.aplicationName;
  }

  ngOnInit(): void {
    this.navigationService.itemsSubject$.pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))).subscribe((it) => {
      this.items = it;
    });
  }

  collapseOpenSidenav() {
    this.layoutService.collapseOpenSidenav();
    if (this.collapsed) document.documentElement.style.setProperty('--sidenav-width', '280px');
  }

  collapseCloseSidenav() {
    this.layoutService.collapseCloseSidenav();
    if (this.collapsed) document.documentElement.style.setProperty('--sidenav-width', '72px');
  }

  toggleCollapse() {
    this.collapsed ? this.layoutService.expandSidenav() : this.layoutService.collapseSidenav();
    document.documentElement.style.setProperty('--sidenav-width', !this.collapsed ? '72px' : '280px');
  }

  trackByRoute(index: number, item: NavigationItem): string {
    return (item as NavigationLink).route;
  }

  openProfileMenu(origin: HTMLDivElement): void {
    this.userMenuOpen$ = of(
      this.popoverService.open({
        content: UiUserMenuComponent,
        origin,
        offsetY: -8,
        width: origin.clientWidth,
        position: [
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap((popoverRef) => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true)
    );
  }

  openSearch(): void {
    // this.dialog.open(SearchModalComponent, {
    //   panelClass: 'ratenow-dialog-glossy',
    //   width: '100%',
    //   maxWidth: '600px'
    // });
  }
}
